module.exports = __webpack_public_path__ + "static/media/stopwatch.7f9e6ff3.svg";